module.exports = __webpack_public_path__ + "img/human-avatar-color.09638fca.svg";